import React, { useState, useCallback } from 'react';
import SignupCollectionAction from '../SignupCollectionAction';

import PaymentMethods from '../PaymentMethods';

const Step7Collection = () => {
    const [isSending, setIsSending] = useState(false);

    const getSending = useCallback((value) => {
        setIsSending(value);
    }, []);

    return (
        <>
            <div className="step-container">
                <div className="step-circle">
                    <span>7</span>
                </div>
                <PaymentMethods getSending={getSending} />
            </div>
            <SignupCollectionAction step={7} isValid={true} isSending={isSending} />
        </>
    );
};

export default Step7Collection;
